import React from 'react';

export default function MetaEditReview({ summary }) {
  return <div className="meta-edit-review">
    <strong>{summary.campaign_name}</strong>
    <p>{summary.account.name || summary.account.id} · {summary.account.currency} · {summary.account.timezone}</p>
    {summary.affected_campaigns && <div><strong>Campaigns using this budget ({summary.affected_campaigns.length})</strong>
      <ul>{summary.affected_campaigns.map((row) => <li key={row.id}>{row.name} · {row.status}</li>)}</ul></div>}
    <table><thead><tr><th>Entity / setting</th><th>Current</th>{summary.recommendation && <th>Original recommendation</th>}<th>Proposed</th></tr></thead>
      <tbody>{summary.rows.map((row) => <tr key={`${row.entity_id}-${row.field}`}>
        <th scope="row">{row.entity} <small>{row.level === 'adset' ? 'Ad set' : row.level} · {row.field}</small></th>
        <td data-label="Current">{row.before}</td>{summary.recommendation && <td data-label="Original recommendation">{row.recommended}</td>}<td data-label="Proposed">{row.after}</td>
      </tr>)}</tbody></table>
    {Object.entries(summary.totals || {}).map(([field, totals]) => <p key={field}><strong>Configured {field === 'daily_budget' ? 'daily' : 'lifetime'} budget total:</strong> {totals.before} → {totals.after}</p>)}
    {summary.budget_impact?.map((impact) => <p key={impact.entity_id}>{impact.name}: configured budget change {impact.change} ({impact.percent}%).</p>)}
    <p>{summary.reason}</p><p>{summary.note}</p>
  </div>;
}
